export default [
  {
    path: '',
    name: 'payment method list',
    component: () => import('@/views/app/payment-method/list/page-list.vue'),
    meta: { title: 'Daftar Metode Pembayaran' },
  },
]
